<template>
  <div>
    <div class="open-platform">
      <TopVedio/>
      <div style="margin-top:80px;">
        <h2>开放平台技术架构</h2>
        <div >
          <div class="architecture-text" style="">
            <div style="width:235px;float:left;">开发者云端平台</div>
            <div style="width:624px;float:left;margin-left:20px;">NOVOBIT</div>
          </div>
          <div class="architecture-text" style="height:auto;font-size: 16px;">  
            <div style="width:228px;float:left;position:absolute;top:10px;">开发者业务系统</div>
            <div style="width:300px;float:left;position:absolute;top:10px;padding: 0 70px;box-sizing: content-box;left:228px;">云端平台</div>
            <div style="width:193px;float:left;position:absolute;top:10px;left:668px">硬件设备</div>
             <img :src="architecture" style="display:block;margin:auto;" alt="">
          </div>
         
        </div>
      </div>
      <div style="width:1050px;margin:auto;margin-top:80px;">
        <h2>接入流程</h2>
        <div style="width:1050px;height:75px;"></div>
        <div class="link-item">
          <img :src="border" alt="">
          联系我们确认需求
        </div>
        <img style="width:40px;height:12px;" :src="arrow" alt="">
        <div class="link-item"><img :src="border" alt=""/>申请Key&access_token</div>
        <img style="width:40px;height:12px;" :src="arrow" alt="">
        <div class="link-item"><img :src="border" alt=""/>调用接口内部开发</div>
        <img style="width:40px;height:12px;" :src="arrow" alt="">
        <div class="link-item"><img :src="border" alt=""/>产品上线</div>
      </div>
    </div>
    <NovoGotop/>
    <NovoFooter/>
  </div>
</template>
<script>
import { NovoFooter, NovoGotop } from "novo-ui";
import TopVedio from "./top-vedio";
export default {
  components: {
    NovoFooter,
    NovoGotop,
    TopVedio
  },
  data() {
    return {
      arrow: require("common/image/open-platform/arrow.png"),
      architecture: require("common/image/open-platform/architecture.png"),
      border:require("common/image/open-platform/border.png")
    };
  }
};
</script>
<style scoped lang="scss" >
.open-platform {
  // width: 1050px;
  padding-top: 80px;
  margin: auto;
  min-height: 996px;
  .architecture-text {
    font-size: 20px;
    color: #000000;
    text-align: center;
    line-height: 76px;
    width: 880px;
    margin: auto;
    height: 76px;
    position: relative;
  }
  .link-item {
    display: inline-block;
    height: 70px;
    width: 220px;
    // border: 1px solid #3ca9ff;
    // border-radius: 37.5px;
    line-height: 70px;
    font-size: 18px;
    color: #000000;
    text-align: center;
    // line-height: 36px;
    img{
      width: 220px;
      display: block;
      position: absolute;
    }
  }
  h2 {
    font-size: 24px;
    color: #000000;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/open-platform/index.vue